// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"9784bfb5","453":"a7e1e95d","805":"3c5a689e"}[chunkId] + ".chunk.js";
};